import {
  ApiMaterialsV1MaterialGradesRetrieveIncludedItems,
  isObject,
  MaterialGradeInfoNested,
  useApiMaterialsV1MaterialGradesRetrieve,
} from 'api';

import { AutocompleteField, AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

const compareNamesDescending = (a: MaterialGradeInfoNested, b: MaterialGradeInfoNested) => b.name.localeCompare(a.name);

export type MaterialGradeAutocompleteProps = Omit<AutocompleteFieldProps<MaterialGradeInfoNested>, 'options'> & {
  includedItems?: ApiMaterialsV1MaterialGradesRetrieveIncludedItems;
};

export const MaterialGradeAutocomplete = (props: MaterialGradeAutocompleteProps) => {
  const { includedItems = 'all', ...rest } = props;
  const { data, isLoading } = useApiMaterialsV1MaterialGradesRetrieve({
    included_items: includedItems,
  });

  return (
    <AutocompleteField<MaterialGradeInfoNested>
      data-testid="material-grade-autocomplete"
      options={data?.results ? [...data.results].sort(compareNamesDescending) : []}
      loading={isLoading}
      getOptionLabel={(option) => {
        if (isObject(option) && option?.name) {
          return option.name;
        }
        return '';
      }}
      valueField="id"
      {...rest}
    />
  );
};
